export const neutral = {
	100: "#FFFFFF",
	200: "#F5F7FC",
	300: "#e1dddd",
	900: "#000000",
}

export const orange = {
	500: "#CA4E3C",
}

export const yellow = {
	500: "#f09a36",
}
